document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    const quickViewBtn = e.target.closest('[bss-b2b-btn-quickview]');
    const minicartBtn = e.target.closest('[bss-b2b-cart-trigger-added]');
    const variantBtns = document.querySelectorAll('label.flex.relative.font-medium.cursor-pointer')
    if (quickViewBtn || variantBtns) {
      setTimeout(() => {
        BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
      }, 1000);
    }
    if (minicartBtn) {
        setTimeout(() => {
            window.dispatchEvent(new Event("scroll"));
        }, 1000);
    }
  });
   // --- CASE 1: click vào icon search trong header ---
    const searchIcon = document.querySelector('.x-header-icon-search.flex.items-center.justify-center.mobile-left-right');
    if (searchIcon) {
        searchIcon.addEventListener('click', triggerScrollWhenSearchReady);
    }

    // --- CASE 2: đang ở trang /search ---
    if (window.location.pathname.includes('/search')) {
    const searchInput = document.querySelector('input.input-search[type="search"]');
    if (searchInput) {
        // Khi user gõ text => kết quả search thay đổi => chờ phần results xuất hiện
        searchInput.addEventListener('input', () => {
            triggerScrollWhenSearchReady();
        });
    }
    }
});

function triggerScrollWhenSearchReady() {
  const interval = setInterval(() => {
    const el = document.querySelector(
      '.overflow-auto.max-h-\\[60vh\\].search-page\\:max-h-\\[45vh\\].scrollbar-body'
    );
    if (el) {
      clearInterval(interval);
      window.dispatchEvent(new Event('scroll'));
    }
  }, 200);

  // tránh chạy mãi
  setTimeout(() => clearInterval(interval), 10000);
}